export function parseMultiDayText(text) {
  const lines = text
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  const result = {
  title: "",
  estimatedBudget: "",
  aiMeta: {
    mood: "",
    energy: "",
    hook: "",
    weatherFeeling: "",
    bestMoment: "",
    crowdMood: "",
    hiddenGem: "",
    tags: [],
  },
  days: [],
};

  let currentDay = null;
  let currentSection = null;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    /* ================= TITLE ================= */
    if (line.startsWith("TITLE:")) {
      result.title = line.replace("TITLE:", "").trim();
      continue;
    }

    /* ================= BUDGET ================= */
    if (/^estimated budget/i.test(line)) {
      result.estimatedBudget = line
        .replace(/estimated budget[:₹]*/i, "")
        .trim();
      continue;
    }
    /* ================= AI META ================= */

if (/^mood:/i.test(line)) {
  result.aiMeta.mood = line.replace(/mood:/i, "").trim();
  continue;
}

if (/^energy:/i.test(line)) {
  result.aiMeta.energy = line.replace(/energy:/i, "").trim();
  continue;
}

if (/^hook:/i.test(line)) {
  result.aiMeta.hook = line.replace(/hook:/i, "").trim();
  continue;
}

if (/^weather feeling:/i.test(line)) {
  result.aiMeta.weatherFeeling = line
    .replace(/weather feeling:/i, "")
    .trim();
  continue;
}

if (/^best moment:/i.test(line)) {
  result.aiMeta.bestMoment = line
    .replace(/best moment:/i, "")
    .trim();
  continue;
}

if (/^crowd mood:/i.test(line)) {
  result.aiMeta.crowdMood = line
    .replace(/crowd mood:/i, "")
    .trim();
  continue;
}

if (/^hidden gem:/i.test(line)) {
  result.aiMeta.hiddenGem = line
    .replace(/hidden gem:/i, "")
    .trim();
  continue;
}

if (/^tags:/i.test(line)) {
  result.aiMeta.tags = line
    .replace(/tags:/i, "")
    .split(",")
    .map((t) => t.trim());

  continue;
}

    /* ================= DAY ================= */
    if (/^day\s+\d+/i.test(line)) {
      currentDay = {
        day: line.toUpperCase(),
        sections: [],
      };
      result.days.push(currentDay);
      currentSection = null;
      continue;
    }

    /* ================= SECTION ================= */
    if (line.startsWith("##")) {
      if (!currentDay) continue;

      currentSection = {
        period: line.replace("##", "").trim(),
        activities: [],
      };

      currentDay.sections.push(currentSection);
      continue;
    }

    if (!currentSection) continue;

    /* ================= HANDLE INLINE LOCATION ================= */
    if (/location:/i.test(line)) {
      const cleanLine = line.replace(/📍/g, "");

      const parts = cleanLine.split(/location:/i);

      const description = parts[0].trim();
      const locationText = parts[1]?.trim() || "";

      if (description) {
        // Case: Paragraph and location in SAME line
        currentSection.activities.push({
          description,
          location: locationText,
        });
      } else {
        // Case: Location on separate line
        const lastActivity =
          currentSection.activities[currentSection.activities.length - 1];

        if (lastActivity) {
          lastActivity.location = locationText;
        }
      }

      continue;
    }

    /* ================= NORMAL PARAGRAPH ================= */
    currentSection.activities.push({
      description: line,
      location: "",
    });
  }

  return result;
}